module.exports = __webpack_public_path__ + "static/media/YS_aplusassured_Trans_EN.ceb5b12f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/YS_aplusassured_Trans_EN.png
// module id = 427
// module chunks = 0